import SearchIconSVG from "assets/svg/search-icon";
import Button from "components/button/button";
import InputField from "components/input/input";
import CustomDropdown from "components/select/custom-select";
import Select from "components/select/select";
import { CATEGORY, CUSTOM_ORDER, JOB_ROLE } from "constants/options";
import _ from "lodash";
import { AnimatePresence, motion } from "motion/react";
import { useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { CgArrowsExchangeV } from "react-icons/cg";
import { FaPlus } from "react-icons/fa";
import { useDialogHook } from "utils/customhooks";
import CustomOrder from "./custom-order";
import SaveFilters from "./save-filters";
import { profileURL } from "utils/utils";
import ShareViewModal from "../more-option/share-view-modal";


/**
 * 
 * @param {{ 
 *  onChange?: (value: string ) => void;
 *  defaultValue?: string;
 * }} param0 
 * @returns 
 */
const SearchInput = ({ onChange, defaultValue }) => {
  const { t, } = useTranslation();

  const [text, setText] = useState(defaultValue ?? "");
  const [debouncedText, setDebouncedText] = useState("");
  const debounceRef = useRef(null);

  useEffect(() => {
    if(debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      setDebouncedText(text);
    }, 600);
  }, [text]);

  useEffect(() => {
      onChange?.(debouncedText);
  }, [debouncedText, onChange]);
 
  return (
    <div className="relative flex flex-row items-center">
      <InputField 
        inputContainerClass="w-full"
        placeholder={t('search')}
        inputClass="min-h-[3.25rem] !pl-[3.25rem] !pr-[1rem] text-base 2sm:min-h-[4.25rem]"
        inputIcon={
          <div className="px-[1.125rem]">
            <SearchIconSVG />
          </div>
        }
        iconPosition="left"
        onChange={e => setText(e.target.value)}
        value={text}
      />

      {!!text && (
        <button
          onClick={() => setText("")} 
          className="absolute right-3 w-7 h-7 flex items-center justify-center rounded-full hover:bg-black/10 transition-all duration-150 text-black/50"
        >
          <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-tj5bde-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
        </button>
      )}
    </div>
  );
};

export default function ListFilter({
  positions = [],
  categories = [],
  jobRole,
  category,
  organizeBy,
  featured,
  onChangeJobRole = () => {},
  onChangeCategory = () => {},
  onChangeOrganizeBy = () => {},
  onChangeFeaturedOnly = () => {},
  onSearchTextChange = (value) => {},
  searchTextDefaultValue = "",
  active = {},
  onClick = () => {},
  permission = {},
  addMilestone = () => {},
  userData,
  profile,
  isYourProfile,
  sort,customOrderJR,customOrderCAT,
  localstorage,http,
  showFilters,
  setProfile = ()=>{},
  hideInViewing = ()=>{}
  
}) {
  const { t, } = useTranslation();
  const custom_order = useDialogHook(CustomOrder);
  const [isLoading,setLoading] = useState(false);
  const [showSaveFilter,setShowSaveFilter] = useState(true); /**hide/show the filter */
  const [savedFilter,setSaveFilter] = useState(false); /**flag to check the save filter */
  /**Will check if the current filter is changed */
  const [organizedByFil, setOganizeByFil] = useState(organizeBy);
  const [sortFil, setSortFil] = useState(sort);
  /**use to checker if milestone filter is null and also effect by changing the filter */
  const [milestone_filter, setMilestonFilter] = useState(profile.milestone_filter);
  const showModalView = useDialogHook(ShareViewModal);

  useEffect(()=>{
    if(organizedByFil === null && sortFil === null) return;
    if(!!profile.milestone_filter){ 
      if(organizedByFil === profile.milestone_filter?.organizeBy && sortFil === profile.milestone_filter?.sort){ 
        setMilestonFilter(profile.milestone_filter)
        setShowSaveFilter(false);
        setSaveFilter(true); 
      }else{
        setMilestonFilter(null)/**set to null to show the save button filter */
        setShowSaveFilter(true);
        setSaveFilter(false)
      }
      
    }else{
      /**this 3 state var must be true to show the save button */
      setMilestonFilter(null)
      setShowSaveFilter(true);
      setSaveFilter(false)
    }
  },[profile.milestone_filter,organizedByFil,sortFil]);

  useEffect(()=>{
    setOganizeByFil(organizeBy)
    setSortFil(sort)
  },[organizeBy,sort])
 

  const hasAddMilestone = useMemo(() => {
    if (!_.isEmpty(permission)) {
      let permissions = ["Super Admin", "Admin", "Staff"];
      let isOwner = permission.status === "owner";
      if (isOwner || permissions.includes(permission.permission.name)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [permission]);

  const openCustomOrder = (groupLabel,selectedOption)=>{
    let sortItem = [];  
    if(selectedOption.value === CUSTOM_ORDER){
      if(groupLabel === CATEGORY){
        if(customOrderCAT.length > 0){
          categories.sort((a, b) => {
            const indexA = customOrderCAT.indexOf(a.name);
            const indexB = customOrderCAT.indexOf(b.name);
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
          });
        } 
        sortItem = categories;
      }else if(groupLabel === JOB_ROLE){ 
        if(customOrderJR.length > 0){
          positions.sort((a, b) => {
            const indexA = customOrderJR.indexOf(a.name);
            const indexB = customOrderJR.indexOf(b.name);
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
          });
        } 
        sortItem = positions;
      } 
      custom_order({sortItem,organizeBy:groupLabel},(callback)=>{
        if(callback?.success){
          let nameOnly = callback?.customName.map(item => item?.name);
          onChangeOrganizeBy({label:groupLabel},selectedOption, nameOnly);
          return;
        }
      })
    } 
    else if(groupLabel === JOB_ROLE || groupLabel === CATEGORY){  
      onChangeOrganizeBy({label:groupLabel},selectedOption); 
    } 
    else if(groupLabel === 'Date'){
      onChangeOrganizeBy({label:groupLabel},selectedOption);
    }
    
    setOganizeByFil(groupLabel);
    setSortFil(selectedOption.value);

  }

  const customHandle = () => {
    let sortItem = [];
    if(organizeBy === JOB_ROLE){ 
      if(customOrderJR.length > 0){
        positions.sort((a, b) => {
          const indexA = customOrderJR.indexOf(a.label);
          const indexB = customOrderJR.indexOf(b.label);
          return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });
      } 
      sortItem = positions;
    } else{
      if(customOrderCAT.length > 0){
        categories.sort((a, b) => {
          const indexA = customOrderCAT.indexOf(a.label);
          const indexB = customOrderCAT.indexOf(b.label);
          return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });
      } 
      sortItem = categories;
    }
    custom_order({sortItem,organizeBy:organizeBy},(callback)=>{
      if(callback?.success){
        let nameOnly = callback?.customName.map(item => item?.label);
        onChangeOrganizeBy({label:organizeBy},{value:sort}, nameOnly);
        return;
      }
    })
  }

  const saveFilterSearch = async(isShare=false)=>{
    setLoading(true);
    let milestone_filter = {
      jobRole:jobRole,
      sort:sort,
      category:category,
      organizeBy:organizeBy,
      customOrderJR:customOrderJR,
      arrange:localstorage.get("filter.arrange"),// this is for the category and Job (ascending, descending and etc.)
      featured:featured,
      customOrderCAT:customOrderCAT,
    }
    if (userData?.profile?.id) {
      try {
        if(isShare){
          const params = new URLSearchParams({
            'share-milestones-view': 'true',
            jr:    JSON.stringify(milestone_filter.jobRole ?? []),
            s:     milestone_filter.sort ?? '',
            c:     JSON.stringify(milestone_filter.category ?? []),
            ob:    milestone_filter.organizeBy ?? '',
            cojr:  JSON.stringify(milestone_filter.customOrderJR ?? []),
            ar:    JSON.stringify(milestone_filter.arrange ?? {}),
            f:     milestone_filter.featured ? '1' : '0',
            cocat: JSON.stringify(milestone_filter.customOrderCAT ?? [])
          });
          console.log(milestone_filter)
          const url = profileURL();
          const link = `${url}?${params.toString()}`;
          showModalView({link},(callback)=>{})
      }else{
        const {status,data} = await http.post(`public/profiles/${userData?.profile.id}/save-filter`, {
          ...milestone_filter,
        });
        if (status === 200) {
          toast.success(data.message);
          setSaveFilter(true);
          setTimeout(()=>{
            setProfile({...profile, milestone_filter: data.milestone_filter});
            setShowSaveFilter(false)
          },5000)
        }
      }
      } catch (err) {
        console.log("error@addViewsToProfile", err); 
        toast.error("It appears that something went wrong");
        throw err;
      }finally{
        setLoading(false);
      }
    }
  }

  const getFormattedLocalTime = ()=> {
    const date = new Date();
    const day = date.getDate(); 
    const month = date.toLocaleString('default', { month: 'long' }); 
    const hours = date.getHours() % 12 || 12; 
    const minutes = date.getMinutes().toString().padStart(2, '0'); 
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

    return `${day}, ${month}, ${hours}:${minutes}${ampm}`;
}

  const showHideFilterForm = ()=>{
    if((isYourProfile && showFilters) && (showSaveFilter && milestone_filter === null)){
      return true;
    }else{
      return false;
    }
  }

  return (
    <div className="w-full mt-2 pb-4.5 2sm:pb-7 3md:pb-13 border-b 2sm:border-b-0 3md:border-b border-gray container-max-width">
      <div className="w-full 2sm:flex 2sm:items-center 2sm:gap-9 relative">
        {/* add milestone */}
        {hasAddMilestone ? (
          <Button
            buttonName={t('addMilestone')}
            buttonTextClass="text-xs 3md:text-sm text-white font-semibold flex items-center justify-center whitespace-normal 2sm:whitespace-nowrap 3md:whitespace-normal"
            buttonRadius="6px"
            iconPosition="left"
            icon={<FaPlus className="mr-2" />}
            buttonClass="relative py-4.5 3md:py-5 px-5 3md:px-10 bg-primary hover:bg-darkPrimary w-full 2sm:w-fit hidden 2sm:block 3md:hidden"
            onClick={addMilestone}
          />
        ) : null}
        {/* selects */}
        <div className="w-full grid grid-cols-2 gap-2 3md:flex  3md:gap-x-3 3md:gap-y-0 filter-container">
          <Select
            value={jobRole}
            formContainer="w-full lg:w-64 z-50"
            options={positions}
            height={40}
            placeholder={t('select')}
            name="job"
            innerLabel={t('Job/Role')}
            innerLabelClass="text-1xs 3md:text-md font-semibold color-select-label leading-3.5 absolute left-4.5 top-3 3md:top-3 inline-flex gap-1 items-center"
            onChange={onChangeJobRole}
            isMulti={true}
            valueContainerClass = "-10px !important"
            popInfoType="job_role"
            showPopInfo = {true}
          />
          <Select
            // value={categories.filter(function (opt) {
            //   return opt.label === category;
            // })}
            value={category}
            formContainer="w-full hidden 3md:block lg:w-64 z-40"
            options={categories}
            height={40}
            placeholder={t('select')}
            name="category"
            innerLabel={t('Category')}
            onChange={onChangeCategory}
            isMulti={true}
            valueContainerClass = "-10px !important"
            popInfoType="category_2"
            showPopInfo = {true}
            innerLabelClass="text-1xs 3md:text-md font-semibold color-select-label leading-3.5 absolute left-4.5 top-3 3md:top-3 inline-flex gap-1 items-center"
          />
          {/* <Select
            value={ORGANIZE_BY.filter(function (option) {
              return option.label === organizeBy;
            })}
            formContainer="w-full lg:w-64"
            options={ORGANIZE_BY}
            height={40}
            placeholder="Select"
            name="sort"
            innerLabel="Organize By"
            innerLabelClass="text-1xs 3md:text-xs font-semibold color-select-label leading-3.5 absolute left-4.5 top-3 3md:top-4"
            onChange={onChangeOrganizeBy}
            valueContainerClass = "-10px !important"
          /> */}
          <CustomDropdown openCustomOrder={openCustomOrder} 
            title={Boolean(userData?.profile?.dateFormat) ? t('organiseBy') : t('organizeBy')} 
            t={t} profileType={profile?.profile_type?.type} 
            showPopup = {true}
            popInfoType="category_2"
            notSidebar={true}
            />
          {
            sort === 'Custom Order' && 
            <Button
              icon={<CgArrowsExchangeV className="text-xl"/>}
              buttonName="Custom"
              buttonRadius="6px"
              iconPosition="left"
              buttonClass="py-4 px-8 bg-gray"
              buttonTextClass="text-black text-sm font-semibold flex items-center justify-center"
              onClick={() => customHandle()}
              />
          }
        </div>
        {/* toggle */}
        <div className="w-full mt-4 2sm:hidden 3md:block 3md:mt-0 3md:w-500">
          <div className="w-full flex items-center justify-between">
            {/* <div className="w-full flex 3md:justify-end items-center space-x-2 3md:space-x-4">
              <p className="text-xs 2sm:text-lg text-lightBlack font-medium">
                Pinned only
              </p>
              <Toggle
                className="w-8.6 h-5 2sm:w-14 2sm:h-8"
                hActiveClass="w-3.5 h-3.5 2sm:w-6 2sm:h-6 ml-auto mr-1 rounded-full bg-white"
                hInactiveClass="w-3.5 h-3.5 2sm:w-6 2sm:h-6 ml-1 rounded-full bg-white"
                checked={featured}
                name="featured"
                onChange={onChangeFeaturedOnly}
              />
            </div> */}
            {/* <div className="flex 2sm:hidden justify-end flex-1">
              <GroupButton
                active={active}
                onClick={(value) => onClick(value)}
              />
            </div> */}
          </div>
        </div>
        <div className="w-full mt-2 2sm:mt-0">
          <SearchInput 
            defaultValue={searchTextDefaultValue}
            onChange={onSearchTextChange}
          />
        </div>
      </div>
        <AnimatePresence initial={false}>
          {/** if the milestone filter empty from db it will show the save button and once it saved it will hide the filter save */
            (showHideFilterForm() && !hideInViewing()) ?
              <motion.div
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0 }}
                key="box"
              > 
                  <SaveFilters 
                    saveFilterSearch={saveFilterSearch} 
                    isLoading={isLoading} 
                    getFormattedLocalTime={getFormattedLocalTime}
                    savedFilter={savedFilter}
                    />
              </motion.div>
                : null
            
          }
      
        </AnimatePresence>
    </div>
  );
}
